import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserForPrescriptionStatusQueryVariables = Types.Exact<{
  userId: Types.Scalars['String'];
}>;


export type UserForPrescriptionStatusQuery = { readonly __typename?: 'Query', readonly user?: { readonly __typename?: 'User', readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null } | null };

export type GetDispensedSkuQueryVariables = Types.Exact<{
  input: Types.GetSkuByIdInput;
  origins?: Types.InputMaybe<ReadonlyArray<Types.InputMaybe<Types.Scalars['String']>> | Types.InputMaybe<Types.Scalars['String']>>;
}>;


export type GetDispensedSkuQuery = { readonly __typename?: 'Query', readonly getSkuById: { readonly __typename?: 'Sku', readonly name: string, readonly externalReferences: ReadonlyArray<{ readonly __typename?: 'SkuExternalReference', readonly foreignId: string, readonly origin: string }> } };


export const UserForPrescriptionStatusDocument = gql`
    query UserForPrescriptionStatus($userId: String!) {
  user(_id: $userId) {
    person {
      firstname
      lastname
    }
  }
}
    `;

/**
 * __useUserForPrescriptionStatusQuery__
 *
 * To run a query within a React component, call `useUserForPrescriptionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserForPrescriptionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserForPrescriptionStatusQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserForPrescriptionStatusQuery(baseOptions: Apollo.QueryHookOptions<UserForPrescriptionStatusQuery, UserForPrescriptionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserForPrescriptionStatusQuery, UserForPrescriptionStatusQueryVariables>(UserForPrescriptionStatusDocument, options);
      }
export function useUserForPrescriptionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserForPrescriptionStatusQuery, UserForPrescriptionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserForPrescriptionStatusQuery, UserForPrescriptionStatusQueryVariables>(UserForPrescriptionStatusDocument, options);
        }
export type UserForPrescriptionStatusQueryHookResult = ReturnType<typeof useUserForPrescriptionStatusQuery>;
export type UserForPrescriptionStatusLazyQueryHookResult = ReturnType<typeof useUserForPrescriptionStatusLazyQuery>;
export type UserForPrescriptionStatusQueryResult = Apollo.QueryResult<UserForPrescriptionStatusQuery, UserForPrescriptionStatusQueryVariables>;
export const GetDispensedSkuDocument = gql`
    query GetDispensedSku($input: GetSkuByIdInput!, $origins: [String]) {
  getSkuById(input: $input) {
    externalReferences(origins: $origins) {
      foreignId
      origin
    }
    name
  }
}
    `;

/**
 * __useGetDispensedSkuQuery__
 *
 * To run a query within a React component, call `useGetDispensedSkuQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDispensedSkuQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDispensedSkuQuery({
 *   variables: {
 *      input: // value for 'input'
 *      origins: // value for 'origins'
 *   },
 * });
 */
export function useGetDispensedSkuQuery(baseOptions: Apollo.QueryHookOptions<GetDispensedSkuQuery, GetDispensedSkuQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDispensedSkuQuery, GetDispensedSkuQueryVariables>(GetDispensedSkuDocument, options);
      }
export function useGetDispensedSkuLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDispensedSkuQuery, GetDispensedSkuQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDispensedSkuQuery, GetDispensedSkuQueryVariables>(GetDispensedSkuDocument, options);
        }
export type GetDispensedSkuQueryHookResult = ReturnType<typeof useGetDispensedSkuQuery>;
export type GetDispensedSkuLazyQueryHookResult = ReturnType<typeof useGetDispensedSkuLazyQuery>;
export type GetDispensedSkuQueryResult = Apollo.QueryResult<GetDispensedSkuQuery, GetDispensedSkuQueryVariables>;